import React from 'react';

const Home: React.FC = () => (
  <div className="home-page" style={{padding: '2rem'}}>
    <h1>Welcome to SmartMesh</h1>
    <p>
      I am an aspiring electrician specializing in smart home automation installs. This brochure site showcases the services and quality you can expect when working with me.
    </p>
    <ul>
      <li>Smart lighting and automation</li>
      <li>Energy-efficient solutions</li>
      <li>Security and access control</li>
      <li>Custom installations for modern living</li>
    </ul>
    <p>
      Explore the site to learn more about my work and how I can help make your home smarter, safer, and more efficient.
    </p>
    <h2>Sample Work</h2>
    <div style={{display: 'flex', gap: '1.5rem', flexWrap: 'wrap', margin: '2rem 0'}}>
      <div style={{width: 220, height: 140, background: '#e0e0e0', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#888', fontSize: 18}}>
        Image 1 Placeholder
      </div>
      <div style={{width: 220, height: 140, background: '#e0e0e0', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#888', fontSize: 18}}>
        Image 2 Placeholder
      </div>
      <div style={{width: 220, height: 140, background: '#e0e0e0', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#888', fontSize: 18}}>
        Image 3 Placeholder
      </div>
    </div>
  </div>
);

export default Home;
